<template>
    <div v-show="!$store.getters.appLoading">
        <transition name="zoom-fade">
            <div v-if="!$store.getters.appLoading">

                <div v-if="hasDreams">
                    <div class="flex justify-end w-full">
                      <PeriodToggle class="ml-2" />
                    </div>

                    <div v-if="hasCurrentDreams">
                        <div v-if="hasCurrentGoals">
                          <GoalsList :forceCollapsed="false" class="my-4"/>
                        </div>

                        <div v-if="!$store.getters.isMobile">
                            <Header :title="isCurrentPeriod ? 'Stay focused on your dreams' : `Dreams in ${month(currentPeriod)}`" class="mt-10" />
                            <DreamsList :focusMode="true" />
                        </div>


                        <NoGoals v-else :hasSomeGoals="hasGoals" :monthInWords="currentPeriodInWords" :past="past" :period="currentPeriod" />

                        <div v-if="$store.getters.isMobile" class="mt-10">
                            <Header :title="isCurrentPeriod ? 'Stay focused on your dreams' : `Dreams in ${month(currentPeriod)}`" />
                            <DreamsList :focusMode="true" />
                        </div>
                    </div>
                    <NoGoals :hasSomeGoals="true" :monthInWords="currentPeriodInWords" :past="past" :period="currentPeriod" v-else />
                </div>

                <NoDreams v-else />

            </div>
        </transition>
    </div>
</template>
<script>
import _ from 'lodash'
import DreamsList from '../Dreams/List'
import GoalsList from '../Goals/List'
import NoDreams from '../Onboarding/NoDreams'
import NoGoals from '../Onboarding/NoGoals'
import PeriodToggle from '../Generic/PeriodToggle'
import {isCurrentPeriod, monthYearFormat, isPastPeriod} from '@/helpers/date'

export default {
  components: {
    DreamsList,
    GoalsList,
    NoDreams,
    NoGoals,
    PeriodToggle
  },
  props: {
    period: {
      type: Date,
      required: false,
      default: () => null,
    }
  },
  watch: {
    period () {
      if (this.period) {
        this.$store.dispatch('SET_CURRENT_PERIOD', this.period)
      }
    }
  },
  computed: {
    currentPeriod () {
      return this.$store.getters.currentPeriod
    },
    hasDreams () {
      return !!_.size(this.$store.getters.allDreams)
    },
    hasCurrentDreams () {
      return !!_.size(this.$store.getters.currentDreams)
    },
    hasGoals () {
      return !!_.size(this.$store.getters.allGoals)
    },
    hasCurrentGoals () {
      return !!_.size(this.$store.getters.goalsByPeriod(this.currentPeriod))
    },
    isCurrentPeriod () {
      return isCurrentPeriod(this.currentPeriod)
    },
    currentPeriodInWords () {
      return monthYearFormat(this.currentPeriod)
    },
    past () {
      return isPastPeriod(this.currentPeriod)
    }
  },
  async mounted () {
    await this.$store.dispatch('RESET_CURRENT_PERIOD')
  },
  methods: {
    month (date) {
      return this.$options.filters.month2(date)
    }
  }
}
</script>
